import React, { ReactElement, Component, useContext, useEffect, useState } from "react";
import { Col, Tabs } from 'antd';
import { DashboardContext, dashboard_item } from "../../contexts/monitor-lists";
import './monitor.less';
import { key_to_title } from "../../shared-functions";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { item } from "../../contexts/items";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
// import { SideFlyInContext } from '../../contexts/side-menu-fly-in';
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
// import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { TableListModalContext } from "../../components/table-list/table-list";
import TableListModal from "../../components/table-list-modal/table-list-modal";
import { table_list_modal_type, TableListModalTypeContext } from "../../contexts/table_list_modal";
import { EnvContext } from "../../contexts/env";
import { datacenter_url } from "../../components/top-navbar/interface";
import { ItemSelectedContext } from "../../contexts/item-selected";

const { TabPane } = Tabs;

export const Monitor: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const dashboards: dashboard_item[] = useContext(DashboardContext)[0],
    // [side_fly_in, set_side_fly_in]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(SideFlyInContext),
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
    namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
    workspaces: workspaces_type_item[] | undefined = useContext(WorkspaceContext)[0],
    item_selected: item = useContext(ItemSelectedContext)[0],
    [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(TableListModalTypeContext),
    env: datacenter_url | undefined = useContext(EnvContext)[0],

    [monitor_frame, set_monitor]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState(<div></div>),
    [frame, set_frame]: [JSX.Element, React.Dispatch<React.SetStateAction<JSX.Element>>] = useState(<div></div>),
    [active_key, set_tab_key]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(''),
    [tabs, set_tab]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState([] as JSX.Element[]),
    path = props.history.location.pathname.substring(1).substring(props.history.location.pathname.substring(1).indexOf('/') + 1),
    [pod_event, set_pod_event]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    theme = sessionStorage.getItem('theme') ? (sessionStorage.getItem('theme') === 'blue') ? 'blue' : 'purple' : 'blue';
  // is_permitted = useMemo(() => role === 'globalAdmin' || role === 'clusterAdmin' || role === 'clusterOwner', [role]);

  // useEffect((): void => {
  //   role !== '' && is_permitted && datacenter_name !== '' && http_get('monitor', ['clusters', set_clusters], role, subscription_id, (cluster_selected || {}).name || '');
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [set_workspaces, set_namespaces, role, subscription_id, set_clusters]);

  useEffect((): void => {
    if (dashboards.length > 0) {
      const db_filter_by_tag = dashboards.filter(dbs => dbs.tags[1] === path);
      if (db_filter_by_tag.length > 0) {
        const tabs_new: JSX.Element[] = [];
        for (let i = 0; i < db_filter_by_tag.length; i++) {
          tabs_new.push(
            <TabPane tab={db_filter_by_tag[i].title === 'rabbitmq' ? 'RabbitMQ' : key_to_title(db_filter_by_tag[i].title)} key={db_filter_by_tag[i].title} />
          );
        }
        set_tab(tabs_new);
      }
    }
  }, [dashboards, path]);

  useEffect((): void => {
    const db_filter_by_tagss = dashboards.filter(dbs => dbs.tags[1] === path);
    if (db_filter_by_tagss.length > 0) {
      let active_inside_tag = db_filter_by_tagss.findIndex(dbb => dbb.title === active_key);
      set_tab_key(active_key && active_inside_tag !== -1 ? active_key : db_filter_by_tagss[0].title);
      const monitor_frame_new: JSX.Element = (
        <Col sm={24} className="px-20 card box_rounded border">
          <Tabs activeKey={active_key} className={`${theme === 'blue' ? 'tab_blue' : 'tab_purple'}`} onChange={(key: string) => {
            set_tab_key(key);
            set_pod_event(false);
          }}>{tabs}</Tabs>
          {frame}
        </Col>
      );
      set_monitor(monitor_frame_new);
    }
  }, [tabs, theme, dashboards, frame, path, workspace_selected, workspaces, active_key]);

  useEffect(():void => {
    if (item_selected?.type === "Restart" && item_selected?.updateTime) {
      set_pod_event(true);
      set_tab_key('pod')
    }
  },[item_selected?.type, item_selected?.updateTime, dashboards])

  useEffect((): void => {
    const db_filter_by_tags = dashboards.filter(dbs => dbs.tags[1] === path);
    if (active_key && dashboards && db_filter_by_tags.length > 0) {
      let indexOfTab: number = (db_filter_by_tags.findIndex(dbs => dbs.title === active_key) === -1 ? 0 : db_filter_by_tags.findIndex(dbs => dbs.title === active_key));
      const { domain }: Document = document,
        default_url =  `https://dashboard-monitoring-ensaas${domain.substr(domain.indexOf('.'))}`,
        frame_new: JSX.Element = (
          // <iframe src={`${env?.["dashboard-monitoring"].externalUrl ? env?.["dashboard-monitoring"].externalUrl : default_url}${db_filter_by_tags[indexOfTab].url}&canSrp&theme=light${`&var-datasource=${cluster_selected?.name}`}${workspace_selected?.labels?.name ? `&var-workspace_name=${workspace_selected.labels.name}` : ''}${workspace_selected?.labels?.name && namespace_selected?.name ? `&var-namespace=${namespace_selected?.name}` : ''}`} title={db_filter_by_tags[indexOfTab].title} className="dashboard_size" />
          // <iframe src={`${env?.["dashboard-monitoring"].externalUrl ? env?.["dashboard-monitoring"].externalUrl : default_url}${(db_filter_by_tags[indexOfTab].url)?.includes("orgId=") ? db_filter_by_tags[indexOfTab].url : db_filter_by_tags[indexOfTab].url + '?orgId=1'}&canSrp&theme=light${`&var-datasource=${cluster_selected?.name}`}${workspace_selected?.labels?.name ? `&var-workspace_name=${workspace_selected.labels.name}` : ''}${workspace_selected?.labels?.name && namespace_selected?.name ? `&var-namespace=${namespace_selected?.name}` : ''}`} title={db_filter_by_tags[indexOfTab].title} className="dashboard_size" />
          <iframe src={`${env?.["dashboard-monitoring"].externalUrl ? env?.["dashboard-monitoring"].externalUrl : default_url}${(db_filter_by_tags[indexOfTab].url)?.includes("orgId=") ? db_filter_by_tags[indexOfTab].url : db_filter_by_tags[indexOfTab].url + '?orgId=1'}&canSrp&theme=light${pod_event ? `&from=${(Number(item_selected?.updateTime)-300)*1000}&to=${(Number(item_selected?.updateTime)+300)*1000}` : ''}${`&var-datasource=${cluster_selected?.name}`}${workspace_selected?.labels?.name ? `&var-workspace_name=${workspace_selected.labels.name}` : ''}${workspace_selected?.labels?.name && namespace_selected?.name ? `&var-namespace=${namespace_selected?.name}` : ''}${pod_event ? `&var-pod=${item_selected?.name}&var-container=${item_selected?.container}` : ''}`} title={db_filter_by_tags[indexOfTab].title} className="dashboard_size" />
        );
      set_frame(frame_new);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active_key, dashboards, path, cluster_selected?.name, workspace_selected?.name, namespace_selected?.name, env?.["dashboard-monitoring"].externalUrl, pod_event]);

  return (
    <TableListModalContext.Provider value={[table_list_modal, set_table_list_modal]}>
      <Col sm={24}>
      <TableListModal />
        {/* {side_fly_in ?
          <MenuUnfoldOutlined className="pl-10 card_title" onClick={() => { set_side_fly_in(!side_fly_in) }} />
          :
          <MenuFoldOutlined className="pl-10 card_title" onClick={() => { set_side_fly_in(!side_fly_in) }} />
        } */}
        {monitor_frame}
      </Col>
    </TableListModalContext.Provider>
  )
}
